import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "listP"
}
const _hoisted_2 = { class: "sec-main listP-main bg-gray" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "活動消息", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "活動消息", -1)
const _hoisted_11 = { class: "col-11 col-md-10 mx-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row text-primary mb-md-5 mb-3" }, "創業新訊", -1)
const _hoisted_13 = { class: "row row-cols-1 flex-nowrap row-cols-md-3 cols-list news-list" }
const _hoisted_14 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_15 = { class: "event-card-logo" }
const _hoisted_16 = { class: "event-card-info p-3 border-top" }
const _hoisted_17 = { class: "event-card-date info-text mb-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "創業新訊", -1)
const _hoisted_19 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_21 = { class: "frcs justify-content-md-end mt-md-4 mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "看更多創業新訊", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-11 col-md-10 mx-auto" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row text-primary mb-md-5 mb-3" }, "近期活動", -1)
const _hoisted_26 = { class: "row row-cols-1 flex-nowrap row-cols-md-3 cols-list event-list" }
const _hoisted_27 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_28 = { class: "event-card-logo" }
const _hoisted_29 = { class: "event-card-info p-3 border-top" }
const _hoisted_30 = { class: "event-card-date info-text mb-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "近期活動", -1)
const _hoisted_32 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_33 = { class: "event-card-location limitLine mb-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_35 = { class: "frcs justify-content-md-end mt-md-4 mt-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "看更多近期活動", -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-11 col-md-10 mx-auto" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row text-primary mb-md-5 mb-3" }, "亮點成果", -1)
const _hoisted_40 = { class: "row row-cols-1 flex-nowrap row-cols-md-3 cols-list highlight-list" }
const _hoisted_41 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_42 = { class: "event-card-logo" }
const _hoisted_43 = { class: "event-card-info p-3 border-top" }
const _hoisted_44 = { class: "event-card-date info-text mb-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "亮點成果", -1)
const _hoisted_46 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_48 = { class: "frcs justify-content-md-end mt-md-4 mt-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "看更多亮點成果", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col align-self-stretch mb-md-4 mb-0"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: {name: 'news-detail', params: { id: item.id }},
                      title: "創業新訊",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", {
                            class: "bg-wrapper",
                            style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-news.png') + ')')
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.date), 1),
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1),
                          _hoisted_20
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: "/news",
                title: "看更多創業新訊",
                class: "btn-anchor",
                aria: "看更多創業新訊"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col align-self-stretch mb-md-4 mb-0"
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      to: {name: 'events-detail', params: { id: item.id }},
                      title: "近期活動",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", {
                            class: "bg-wrapper",
                            style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(item.date), 1),
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, _toDisplayString(item.name), 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(item.location), 1),
                          _hoisted_34
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_router_link, {
                to: "/events",
                title: "看更多近期活動",
                class: "btn-anchor",
                aria: "看更多近期活動"
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.achievementItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col align-self-stretch mb-md-4 mb-0"
                }, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_router_link, {
                      to: {name: 'achievements-detail', params: { id: item.id }},
                      title: "亮點成果",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", {
                            class: "bg-wrapper",
                            style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-highlight.png') + ')')
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(item.date), 1),
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, _toDisplayString(item.title), 1),
                          _hoisted_47
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: "/achievements",
                title: "看更多亮點成果",
                class: "btn-anchor",
                aria: "看更多亮點成果"
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '活動消息']
  ])
}